import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccountStore } from '../../../../../components/Stores/accountStore';
import ButtonDesigned from '../../../../../components/UI-Elements/Buttons/ButtonDesigned';
import { Product } from '../../../../../sp-types/productType';
import { isProductValidToSave, saveProductOnDb } from '../../../productUtils';
import { ProductModifyAdvanced } from './components/ProductModifyAdvanced';
import { ProductModifyInputFields } from './components/ProductModifyInputFields';
import { ProductModifyMaterials } from './components/ProductModifyMaterials';

interface Props {
  product: Product;
  setProduct: React.Dispatch<React.SetStateAction<Product>>;
}

export const AddNewProductModify: React.FC<Props> = ({ product, setProduct }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { account } = useAccountStore();

  return (
    <div className="flex flex-col flex-1 px-11 py-6 gap-7 overflow-auto">
      <div className="flex flex-col gap-2 ">
        <p className="text-xl">Modify settings product</p>
        <p className="text-sm text-gray-700">Fill in and adjust product adjustment</p>
      </div>
      <div className="overflow-auto">
        <ProductModifyInputFields product={product} setProduct={setProduct} />
      </div>
      <div className="flex flex-1 overflow-auto">
        <ProductModifyMaterials product={product} setProduct={setProduct} />
      </div>
      <div className="flex flex-col gap-20 ">
        <ProductModifyAdvanced />
        <div className="flex flex-row gap-3">
          <ButtonDesigned
            className="py-2 px-4"
            style="outline"
            onButtonClick={() => {
              navigate('/dashboard');
            }}
          >
            Cancel
          </ButtonDesigned>
          <ButtonDesigned
            isFunctionLoading={isLoading}
            disableButton={!isProductValidToSave(product)}
            className="py-2 px-4"
            onButtonClick={() => {
              saveProductOnDb(
                product,
                account.id || '1',
                setIsLoading,
                (uuid?: string) => uuid && navigate(`/products-dashboard/${uuid}`),
              );
            }}
          >
            Save
          </ButtonDesigned>
        </div>
      </div>
    </div>
  );
};
